// @flow
import React from 'react';
import Link from '@waglabs/link';
import { Location } from '@reach/router';

import {
  addUTMParamsToURL,
  type UTMParams,
} from '../../../services/Tracking/utm';

type Props = {
  children: any,
  destinationUrl: string,
  utmParams?: UTMParams,
};

const handleLocationRender = ({
  children,
  destinationUrl,
  utmParams,
  ...rest
}: Props) => ({ location }: { location: typeof location }) => (
  <Link
    href={addUTMParamsToURL(destinationUrl, utmParams, location)}
    {...rest}
  >
    {children}
  </Link>
);

const TrackableLink = ({
  children,
  destinationUrl,
  utmParams,
  ...rest
}: Props) => (
  <Location>
    {handleLocationRender({
      children,
      destinationUrl,
      utmParams,
      ...rest,
    })}
  </Location>
);

TrackableLink.defaultProps = {
  utmParams: {},
};

export default TrackableLink;
